<ng-container *ngIf="IsHomeDashboardCompany">
    <span class="part1">Home</span><span class="part2">Dashboard <sup>®</sup></span>
</ng-container>

<ng-container *ngIf="!IsHomeDashboardCompany">
    <span *ngIf="lgvCompanySvc.Company$ | async as company">{{company.name}}</span>
</ng-container>
